import React from 'react';
import styles from './UltraAppCarousel.module.scss';
import { Carousel } from '../../Carousel';
import { Image as FiImage } from '../../Image';

export default function UltraAppCarousel() {
  const images = ['/product_images/ultra/app-ui-homescreen-1.png', '/product_images/ultra/app-ui-homescreen-2.png'];

  return (
    <div className={styles.appCarouselSection}>
      <Carousel className={styles.mobileAppCarousel} wrapAround={true} prevNextButtons={true}>
        {images.map((url, index) => (
          <div key={index} className={styles.mobileAppImage}>
            <FiImage
              image={{
                type: 'image',
                url: url,
                descriptors: ['1000w'],
              }}
              loading="eager"
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}
